import { render, staticRenderFns } from "./SocialSwitcher.vue?vue&type=template&id=227001eb&scoped=true&"
import script from "./SocialSwitcher.vue?vue&type=script&lang=js&"
export * from "./SocialSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SocialSwitcher.vue?vue&type=style&index=0&id=227001eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227001eb",
  null
  
)

export default component.exports